var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 283,
    viewBox: "0 0 1920 283",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_165_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 283H1920V0.0313698H0V283Z",
    fill: "url(#paint0_linear_165_93)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 151.607C106.494 207.908 359.434 298.227 584 239.689C657.126 220.627 741.47 195.515 829.863 169.198C1089.59 91.8676 1384.27 4.13161 1532 28.9059C1618.54 43.4196 1706.61 131.852 1781.02 206.559C1810.28 235.939 1837.42 263.196 1861.53 283H1920V0.0313698H0L0 151.607Z",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 282.969H1920V0H0V282.969Z",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_165_93",
    x: -139,
    y: -139,
    width: 2198,
    height: 561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 69.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_165_93"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_165_93",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_93",
    x1: -0.00000645519,
    y1: 18.6046,
    x2: 838.947,
    y2: 1147.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0162474,
    stopColor: "#9333EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EBF8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter2);
export default __webpack_public_path__ + "static/media/footer2.9c567b06114a1ea532e3dbcfe715bf18.svg";
export { ForwardRef as ReactComponent };